import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import LinkSectionBooks from 'modules/Programs/components/LinksSection/Books';
import LinkSectionFiles from 'modules/Programs/components/LinksSection/Files';
import LinkSectionHelpfulLinks from 'modules/Programs/components/LinksSection/Links';

import { IChunksModel } from '@common/models/Chunks/Chunks';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

import { StyledLessonDescriptionDetailsWrap } from './styled';

interface PropsType {
	lessonModel: IStudentLessonModel;
	chunksModel: IChunksModel;
}

function LessonDescriptionDetails({ lessonModel, chunksModel }: PropsType) {
	const { t } = useTranslation();

	const files = chunksModel.fileChunks;
	const { books } = lessonModel.lesson_info;

	// Show plug text if there are information about lesson(books, links, files)
	// eslint-disable-next-line
	const showPlug =
		files?.length <= 0 &&
		books?.length <= 0 &&
		!lessonModel.schedule_program?.zoom_link &&
		!lessonModel.schedule_program?.miro_link;
	return (
		<StyledLessonDescriptionDetailsWrap>
			{showPlug && <Typography variant="body2">{t('lesson.emptyDetails')}</Typography>}
			<LinkSectionHelpfulLinks lessonModel={lessonModel} />
			<LinkSectionBooks books={books} />
			<LinkSectionFiles files={files} />
		</StyledLessonDescriptionDetailsWrap>
	);
}

export default LessonDescriptionDetails;
